import React, {useEffect} from 'react';
import {Dropdown} from 'primereact/dropdown';
import {InputText} from 'primereact/inputtext';
import {useAppDispatch, useAppSelector} from "../../../redux/hooks";
import {getQueueIVRType, buildIvrDropdownOptions} from "../../../redux/api/apiQueue";
import {classNames} from "primereact/utils";
import {setQueueField} from "../../../redux/actions/actionsQueue";
import {checkPermissions} from "../../../redux/permissions/permissionsUtils";
import IVRConfigurationDialog from "../../Settings/IVRConfigurationList/IVRConfigurationDialog";

const QueueDialog_IVR_ACD = () => {
    const dispatch = useAppDispatch()
    const queueData = useAppSelector(state => state.QueueListReducer.queueData);
    const archiveTableToggle = useAppSelector(state => state.QueueListReducer.archiveQueueTableToggle);
    const editType = useAppSelector(state => state.UsersReducer.editType);
    const rolesVision = useAppSelector(state => state.RolesReducer.rolesVision) as unknown as Record<string, string[]>;
    const ivrPermissions = checkPermissions(rolesVision, 'Queues');
    const errorFields = useAppSelector(state => state.QueueListReducer.errorFields);
    const jwtToken = useAppSelector(state => state.UsersReducer.userData.jwtToken);
    const detailsLoadingQueue = useAppSelector(state => state.QueueListReducer.detailsLoading);
    const ivrIsBlock = queueData?.permission?.ivrIsBlock;
    const disabledInputClass = classNames('w-full', {'opacity-100': archiveTableToggle && editType});
    useEffect(() => {
        if (detailsLoadingQueue) {
            return;
        }
        if (ivrIsBlock) {
            return;
        }
        dispatch(getQueueIVRType(jwtToken?.jwtToken));
    }, [ivrIsBlock, detailsLoadingQueue, queueData?.queue?.id, jwtToken?.jwtToken]);
    const IVRConfiguration = useAppSelector(state => state.QueueListReducer.IVRConfiguration);
    const selectedIvrId = queueData?.queueACD?.ivrConfigurationId ?? queueData?.queueACD?.ivrConfiguration?.[0]?.id ?? null;
    const ivrDropdownOptions = buildIvrDropdownOptions(
        IVRConfiguration,
        selectedIvrId,
        queueData?.queueACD?.ivrConfigurationName
    );
    const ivrBlockedValue = [
        queueData?.queueACD?.ivrConfigurationId,
        queueData?.queueACD?.ivrConfigurationName
    ].filter((part) => part != null && String(part).trim() !== '').join(' ');

    return (
        <div className="acd-settings grid">
            <div className="p-fluid grid col-12 md:col-12 pl-2">
                <div className="p-fluid field col-12 md:col-4 mb-0">
                    <div className="pl-0 pr-1">
                        <label htmlFor="ivrConfig" className="block mb-3">IVR Config</label>
                        <div className="flex align-items-center">
                            {ivrIsBlock ? (
                                <InputText
                                    id="ivrConfig"
                                    className={classNames(disabledInputClass, 'mt-2 mr-2', {'p-invalid': errorFields?.ivrConfigurationId})}
                                    disabled
                                    value={ivrBlockedValue}
                                />
                            ) : (
                            <Dropdown
                                id="ivrConfig"
                                appendTo="self"
                                filter
                                value={selectedIvrId != null && selectedIvrId !== ''
                                    ? (Number.isFinite(Number(selectedIvrId)) ? Number(selectedIvrId) : selectedIvrId)
                                    : null}
                                options={ivrDropdownOptions}
                                optionLabel="label"
                                optionValue="flowId"
                                className={classNames('mt-2 mr-2 w-full', {'p-invalid': errorFields?.ivrConfigurationId})}
                                disabled={!archiveTableToggle || !editType}
                                onChange={(e) => {
                                    dispatch(setQueueField({
                                        section: 'queueACD',
                                        fieldName: 'ivrConfigurationId',
                                        value: e.value
                                    }));
                                }}
                                placeholder="Виберіть IVR конфігурацію"
                            />
                            )}
                            {/*{(queueData?.queueACD?.ivrConfigurationId ?? queueData?.queueACD?.ivrConfiguration?.[0]?.id) && (*/}
                            {/*    <Button*/}
                            {/*        type="button"*/}
                            {/*        icon={ivrPermissions.update ? 'pi pi-pencil' : 'pi pi-eye'}*/}
                            {/*        className="p-button-secondary p-button-text ml-2 mt-2"*/}
                            {/*        disabled={!archiveTableToggle}*/}
                            {/*        onClick={() => {*/}
                            {/*            const ivrId = queueData.queueACD.ivrConfigurationId ?? queueData.queueACD.ivrConfiguration?.[0]?.id;*/}
                            {/*            if (!ivrId) return;*/}
                            {/*            dispatch(setSelectedIVRConfigurationIndex(ivrId));*/}
                            {/*            dispatch(getIVRConfigurationById(ivrId, jwtToken?.jwtToken));*/}
                            {/*            dispatch(setIVRConfigurationErrorFields(null));*/}
                            {/*            dispatch(setIVRConfigurationDialogVisible(true));*/}
                            {/*            dispatch(setEditType(ivrPermissions.update));*/}
                            {/*        }}*/}
                            {/*    />*/}
                            {/*)}*/}
                        </div>
                    </div>
                </div>
                {errorFields?.ivrConfigurationId && <div className="col-12 md:col-12 pt-2 px-0 pb-0">
                    <span className="title p-error text-sm">
                        {errorFields?.ivrConfigurationId?.ivrConfigurationId}
                    </span>
                </div>}
            </div>
            <IVRConfigurationDialog/>
        </div>
    );
};

export default QueueDialog_IVR_ACD;

